import * as React from 'react';
import * as Redux from 'redux';
import { IErrorType, IResults } from '../../state-helpers/search-results';
import { IEpiProps } from '../../state-helpers/epi-props';
import { clearErrorText } from '../../actions/index';
import { ISearchAppState } from '../../reducers/index'


export interface IErrorProps {
    epiProps: IEpiProps;
    results: IResults;

    onDismiss: () => void;
}


export class Error extends React.Component<IErrorProps, any> {

    render() {
        const errorText = this.props.results.errorType === IErrorType.TIME_OUT
            ? this.props.epiProps.connectionErrorText
            : this.props.epiProps.generalErrorText;

        return (
			<div className="alert-message-search alert-message-search-error" role="dialog">
				<div className="alert-message-search-content">
					<div className="alert-message-search-content-icon">
						<svg>
							<use xlinkHref="#icon-error"></use>
						</svg>
                    </div>
                    <div className="alert-message-search-content-text" dangerouslySetInnerHTML={{ __html: errorText }} />
                </div>

                <div className="alert-message-search-close" onClick={this.props.onDismiss}>
                    <p><u>Dismiss</u></p>
                </div>
            </div>
        );
    }
}